import { Level1, Level10, Level2, Level3, Level4, Level5, Level6, Level7, Level8, Level9, } from "../icons/levels";

export const FaceitLevel = ({ level }: { level: number }) => {
    const levelImages: { [key: number]: JSX.Element } = {
        1: <Level1 />,
        2: <Level2 />,
        3: <Level3 />,
        4: <Level4 />,
        5: <Level5 />,
        6: <Level6 />,
        7: <Level7 />,
        8: <Level8 />,
        9: <Level9 />,
        10: <Level10 />,
    };

    const imageUrl = levelImages[level] || levelImages[1];

    return <>{imageUrl}</>;
}